<template>
  <div>
    <v-card>
      <v-toolbar dense>{{ $t('page_title')}}</v-toolbar>

      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <template v-if="newSection">
            <v-card>
              <v-toolbar color="pink" dark flat>Neue AutoCompletion</v-toolbar>

              <v-card-text>
                <v-text-field
                  :rules="[rules.id]"
                  outline
                  v-model="newSection.idInput"
                  auto-grow
                  label="Id"
                  validate-on-blur
                  :disabled="isLoading"
                />
                <v-text-field
                  :rules="[rules.title]"
                  outline
                  v-model="newSection.titleInput"
                  auto-grow
                  label="Titel"
                  validate-on-blur
                  :disabled="isLoading"
                />

                <v-textarea
                  label="Data"
                  :rules="[rules.json]"
                  outline
                  v-model="newSection.dataInput"
                  auto-grow
                  validate-on-blur
                  :disabled="isLoading"
                ></v-textarea>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  @click="saveSection(newSection)"
                  :disabled="isLoading"
                >{{ $t('save') }}</v-btn>
              </v-card-actions>
            </v-card>
          </template>
          <template v-else>
            <v-btn
              @click="createNewAutoCompletion"
              :disabled="isLoading"
            >Erstelle einen neue AutoCompletion</v-btn>
          </template>
        </v-flex>

        <v-flex xs12 pa-2 v-for="(section, idx) in sections" :key="idx">
          <v-card>
            <v-toolbar color="pink" dark flat>AutoCompletion für {{ section.titleInput }}</v-toolbar>

            <v-card-text>
              <v-text-field
                :rules="[rules.id]"
                outline
                v-model="section.idInput"
                auto-grow
                label="Id"
                validate-on-blur
                readonly
                :disabled="isLoading"
              />
              <v-text-field
                :rules="[rules.title]"
                outline
                v-model="section.titleInput"
                auto-grow
                label="Titel"
                validate-on-blur
                :disabled="isLoading"
              />

              <v-textarea
                label="Data"
                :rules="[rules.json]"
                outline
                v-model="section.dataInput"
                auto-grow
                validate-on-blur
                :disabled="isLoading"
              ></v-textarea>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="success"
                @click="saveSection(section)"
                :disabled="isLoading"
              >{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <!--<v-card-text>
        <v-btn @click="saveSectioniguration" color="success">Reset to Standard - BE CAREFULL</v-btn>
      </v-card-text>-->
    </v-card>
  </div>
</template>

<i18n>
  {
    "de": {
      "page_title" : "Kundendaten",
      "save" : "Speichern"
    },
    "en": {
      "page_title" : "Customer Data",
      "save" : "Save"
    }
  }
</i18n>

<script>
import { mapActions, mapGetters } from "vuex";

import { api, validatingCastIdName } from "@/store/modules/autocompletes";
import { api as appApi } from "@/store/modules/app";

export default {
  data() {
    return {
      newSection: null,
      isLoading: false,
      rules: {
        json: v => {
          try {
            console.log("ugly", v);
            const a = JSON.parse(v);
            console.log("a", a);
            if (!(a instanceof Array)) {
              throw new TypeError("The base element must be an array[]");
            }

            console.log("JSON", a);
            return a.every((kv, i) => validatingCastIdName(kv, i));
          } catch (e) {
            console.error(e);
            return `Invalid input: ${e}`;
          }
        },
        title: v => {
          return (
            (typeof v === "string" && v.trim().length >= 1) ||
            "Title must be a non empty text"
          );
        },
        id: v => {
          return (
            /^[a-z][a-z0-9]+$/.test(v.trim()) ||
            "The id must match the pattern [a-z][a-z0-9]+"
          );
        }
      }
    };
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.getAutoCompleteData]),
    sections() {
      console.log("getAutoCompleteData", this.getAutoCompleteData);
      return Object.entries(this.getAutoCompleteData).map(([id, value]) => {
        return {
          ...value,
          id,
          title: value.title || id,
          titleInput: value.title || id,
          idInput: id,
          dataInput: JSON.stringify(value.data, undefined, 2)
        };
      });
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.updateAutoCompleteData,
      api.actions.createAutoCompleteData
    ]),
    ...mapActions(appApi.namespace, [appApi.actions.addStatus]),
    createNewAutoCompletion() {
      const id = "";
      const value = {
        id,
        title: "",
        data: [
          {
            id: "theId",
            name: "theName"
          }
        ]
      };
      this.newSection = {
        ...value,
        id,
        title: value.title || id,
        titleInput: value.title || id,
        idInput: id,
        dataInput: JSON.stringify(value.data, undefined, 2)
      };
    },

    saveSection(segment) {
      this.isLoading = true;
      try {
        const idInput = segment.idInput;
        const idValid = this.rules.id(idInput);
        if (idValid !== true) {
          throw new Error(idValid);
        }

        const dataInput = segment.dataInput;
        const dataValid = this.rules.json(dataInput);
        if (dataValid !== true) {
          throw new Error(dataValid);
        }
        const rawData = JSON.parse(dataInput);

        const titleInput = segment.titleInput;
        const titleValid = this.rules.title(titleInput);
        if (titleValid !== true) {
          throw new Error(titleValid);
        }

        if (
          titleInput.trim() === segment.title.trim() &&
          idInput.trim() === segment.id.trim() &&
          JSON.stringify(rawData) === JSON.stringify(segment.data)
        ) {
          console.log("nothing changed data will not be saved");
          this.addStatus({
            type: "success",
            message: `${titleInput} no changes found`
          });

          return;
        }

        const storeData = {};
        Object.entries(segment).forEach(([id, value]) => {
          if (!["idInput", "dataInput", "titleInput"].includes(id)) {
            storeData[id] = value;
          }
        });

        storeData.id = idInput.trim();
        storeData.data = rawData;
        storeData.title = titleInput.trim();
        const storeFunction =
          this.newSection === segment
            ? this.createAutoCompleteData
            : this.updateAutoCompleteData;
        storeFunction(storeData)
          .then(() => {
            this.addStatus({
              type: "success",
              message: `${titleInput} gespeichert`
            });
            this.newSection = null;
            this.isLoading = false;
          })
          .catch(err => {
            this.addStatus({
              type: "error",
              message: `${titleInput} speichern fehlgeschlagen` + String(err)
            });
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Save failed:", error);
        this.addStatus({ type: "error", message: String(error) });
        this.isLoading = false;
      }
    }
  }
};
</script>
